module.exports = __webpack_public_path__ + "img/TX.adab906b.png";